// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__msDMl","right":"styles_right__PxIq-"};